export default __webpack_public_path__ + "static/media/car-icon.ded85c1b.svg";